import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import BrandDetail from "@/pages/BrandDetail";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center bg-ink text-slate-300 p-8 text-center">
          <div>
            <p className="font-display text-3xl text-white uppercase">Something went wrong</p>
            <p className="mt-2 text-sm text-slate-500">Please reload the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <LanguageProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brands/:id" element={<BrandDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster
        theme="dark"
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#0d2b4a",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.12)",
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
